import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 引入主题变量系统
import './themes/variables.css'
import { applyTheme } from './utils/theme'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 应用平台主题（拆分后每个平台独立，无需切换）
applyTheme()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
